<style scoped lang="stylus" rel="stylesheet/stylus">
.container
  background #f7f8fa
  min-height 100%
  padding 16px
  .item
    margin-bottom 24px
    .item-title
      font-size 13px
      line-height 18px
      color #323233
      margin-bottom 4px
      .need
        font-size 13px
        line-height 18px
        color rgb(255,72,66)
      .tip
        font-size 12px
        color rgba(50, 50, 51, 0.46)
    .image-container
      margin-right -8px
      margin-bottom 24px
      flex-wrap wrap
      .imageBox
        position relative
        width 109px
        height 109px
        margin-top 8px
        margin-right 8px
        .uploadImg
          width 109px
          height 109px
        .deleteImgBtn
          position absolute
          top -13px*0.5
          right -13px*0.5
      .addImgBtn
        position relative
        width 109px
        height 109px
        margin-top 8px
        margin-right 8px
        background #EBECF0
        border-radius 6px
        color #969799
        .camera
          font-size 30px
          margin-bottom 15px
        .addImgBtnText
          font-size 12px
          line-height 18px
          text-align center
  .btnsBox
    padding 28px 0
    .execBtn
      display flex
      align-items center
      justify-content center
      width 100%
      height 44px
      font-size 17px
      border-radius 4px
    .submitBtn
      color rgb(255,255,255)
      background #266BFF
    .cancelBtn
      color rgb(0,0,0)
      background rgba(255,255,255,0.9)
</style>

<template>
	<video-poster ref="videoPoster" class="container">
		<div class="item">
			<div class="item-title flex-row-bet-end">
				上传视频(选择完视频后自动获取封面)
				<span class="tip">建议小于15秒</span>
			</div>
			<div class="image-container">
				<video-uploader @changed="videoChanged"></video-uploader>
			</div>
		</div>
		<div class="item">
			<div class="item-title flex-row-bet-end">
				预览视频(后台提供封面)
				<span class="tip"></span>
			</div>
			<div class="image-container flex-row-sta-cen">
				<div class="imageBox" v-for="(video, index) in previewVideos" :key="index">
					<video-previewer
						style="width: 100%;height: 100%;"
						:src="video.src"
						:poster="video.poster"
					></video-previewer>
				</div>
			</div>
		</div>
		<div class="btnsBox">
			<div class="execBtn submitBtn com-active-white" @click="submit">打印到控制台</div>
			<!--<div class="execBtn cancelBtn" @click="cancel">取消</div>-->
		</div>
	</video-poster>
</template>

<script>
import videoPoster from '../../components/business/video-poster'
import videoUploader from '../../components/business/video-uploader'
import videoPreviewer from '../../components/business/video-previewer'
export default {
	name: 'callCamera',
	components: {
		videoPoster,
		videoUploader,
		videoPreviewer
	},
	props: {},
	filters: {},
	computed: {},
	data() {
		return {
			uploadVideos: [], // 上传视频
			previewVideos: [
				{
					src: 'https://www.runoob.com/try/demo_source/movie.mp4',
					poster: 'https://www.runoob.com/images/pulpit.jpg'
				},
				{
					src: 'https://www.runoob.com/try/demo_source/mov_bbb.mp4',
					poster: 'https://www.runoob.com/images/logo.png'
				},
				{
					src: 'https://www.runoob.com/try/demo_source/movie.mp4',
					poster: 'https://www.runoob.com/images/pulpit.jpg'
				},
				{
					src: 'https://www.runoob.com/try/demo_source/mov_bbb.mp4',
					poster: 'https://www.runoob.com/images/logo.png'
				}
			] // 预览视频
		}
	},
	methods: {
		// 上传视频文件变更
		videoChanged(videoList) {
			this.uploadVideos = videoList.map(video => video.file)
		},
		submit() {
			console.log('上传视频文件变更', this.uploadVideos)
		}
	},
	created() {},
	mounted() {}
}
</script>
